const prod  = 'https://nebula.api.imilo.pl/';
const local = 'http://localhost:8000/';

export const API_URL = (function(){
  const api = process.env.REACT_APP_API;
  if(api === 'prod') {console.log('%c production server ' + prod, 'color: red; font-weight: bold;'); return prod;}
  if(api === 'local') {console.log('%c local server ' + local, 'color: blue; font-weight: bold;'); return local;}
  return prod;
})();

export const NODE_ENV = JSON.parse(JSON.stringify(process.env.NODE_ENV));



// WEBPACK FOOTER //
// ./src/ENDPOINTS.js